import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { CardHomeBase, StyleCardHome } from './CardHomeBase';
import { VerifiedIcon } from './VerifiedIcon';
import { LinkedinVerificationStatus, useCurrentParticipant } from '@app/api';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  column: {
    padding: [theme.marginBase * 5, 0, theme.marginBase * 7, 0],
  },
}));

interface Props {
  className?: string;
}

export const VerifiedProfileIconsCard = ({ className }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: participant } = useCurrentParticipant();

  if (!participant) return null;

  if (
    participant.emailValidated &&
    participant.linkedinVerificationStatus ===
      LinkedinVerificationStatus.VERIFIED
  )
    return null;

  return (
    <CardHomeBase
      style={StyleCardHome.INK}
      icon="ri-question-mark"
      title={t('home.profileVerification.title')}
      className={classnames(classes.column, className)}
    >
      <div className={classes.container}>
        <VerifiedIcon
          icon="ri-mail-line"
          verified={participant.emailValidated}
          link="/profile/contact-details"
        />
        <VerifiedIcon
          icon="ri-linkedin-box-fill"
          verified={
            participant.linkedinVerificationStatus ===
            LinkedinVerificationStatus.VERIFIED
          }
          link="/profile/professional-profile"
        />
      </div>
      <p>
        <Trans
          i18nKey="home.profileVerification.description"
          components={{ b: <b /> }}
        />
      </p>
    </CardHomeBase>
  );
};
